import { Composition, staticFile } from "remotion";
import { TDCPromoVideo, tdcPromoVideoSchema } from "./compositions/TDCPromoVideo";
import { TDCEuFuiVideo, tdcEuFuiVideoSchema } from "./compositions/TDCEuFuiVideo";
import { DEFAULT_EDITION } from "../lib/editions";
import { FPS, TOTAL_FRAMES, COMPOSITION_WIDTH, COMPOSITION_HEIGHT } from "../lib/types";
import { DEFAULT_TRILHA_KEY } from "../lib/promo-form-config";

const promoDefaultProps = {
  role: "palestrante" as const,
  palestraType: DEFAULT_TRILHA_KEY,
  speakerName: "Nome Palestrante",
  speakerTitle: "Job @ Company",
  talkTitle: "Como evoluir na Carreira como Profissional de Dados?",
  photoUrl: staticFile("/user-placeholder.png"),
  photoOffsetX: 0,
  photoOffsetY: 0,
  photoScale: 1,
  speaker2Name: "",
  speaker2Title: "",
  photoUrl2: "",
  photoOffsetX2: 0,
  photoOffsetY2: 0,
  photoScale2: 1,
  sharedPhoto: false,
  editionSlug: DEFAULT_EDITION,
  showSafeArea: false,
};

const euFuiDefaultProps = {
  photoUrl: staticFile("/user-placeholder.png"),
  photoOffsetX: 0,
  photoOffsetY: 0,
  photoScale: 1,
  editionSlug: DEFAULT_EDITION,
  editionNameLine1: "TDC Floripa 2026",
  editionNameLine2: "#EuFui",
  showSafeArea: false,
};

export const RemotionRoot = () => {
  return (
    <>
      <Composition
        id="TDCPromoVideo"
        component={TDCPromoVideo}
        durationInFrames={TOTAL_FRAMES}
        fps={FPS}
        width={COMPOSITION_WIDTH}
        height={COMPOSITION_HEIGHT}
        schema={tdcPromoVideoSchema}
        defaultProps={promoDefaultProps}
      />
      <Composition
        id="TDCEuFuiVideo"
        component={TDCEuFuiVideo}
        durationInFrames={TOTAL_FRAMES}
        fps={FPS}
        width={COMPOSITION_WIDTH}
        height={COMPOSITION_HEIGHT}
        schema={tdcEuFuiVideoSchema}
        defaultProps={euFuiDefaultProps}
      />
    </>
  );
};
